<template>
  <Transition name="modal">
    <div
      v-if="show"
      class="modal-mask"
    >
      <div class="modal-wrapper">
        <div
          ref="popup"
          v-click-outside="close"
          :class="{'modal-container': true, 'modal-container--scrollable': scrollable}"
        >
          <div ref="content">
            <base-panel additional-classes="panel--popup" :additional-heading-classes="'panel-heading ed_panel_heading_actionbar panel-heading--grey'">
              <template #heading>
                <div class="row">
                  <div class="col-sm-11">
                    <slot name="heading" />
                  </div>
                  <div class="col-sm-1 text-right">
                    <base-button
                      class="fa fa-close item item--active"
                      color="link"
                      @click="close()"
                    />
                  </div>
                </div>
              </template>
              <slot />
              <template
                #footer
                v-if="$slots.footer"
              >
                <slot name="footer" />
              </template>
            </base-panel>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import BasePanel from '@/components/BasePanel.vue';
import BaseButton from '@/components/BaseButton.vue';

/**
 * Die Komponente für die anzeige eines Popups auf der Seite
 * @displayName AppPopup
 */
export default {
  name: 'AppPopup',
  components: {
    BasePanel,
    BaseButton
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close'],
  data() {
    return {
      timer: false,
      scrollable: false,
    }
  },
  watch: {
    show() {
      this.assessHeight();
    }
  },
  created() {
    window.addEventListener('resize', this.assessHeight);
  },
  unmounted() {
    window.removeEventListener('resize', this.assessHeight);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    assessHeight() {
      clearTimeout(this.timer);

      this.timer = setTimeout(() => {
        if (this.show) {
          this.scrollable = this.$refs['popup'].clientHeight < this.$refs['content'].clientHeight;
        }
      }, 200)
    }
  }
}
</script>

<style lang="less">
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 90px; // magic number nav
  bottom: 90px; // magic number proven experts banner
  left: 0;
  width: 100%;
  height: calc(100% - 180px);
  display: table;
  transition: opacity 0.3s ease;

  &:before {
    content: '';
    display: block;
    position: absolute;
    z-index: 9998;
    top: -90px; // magic number nav
    bottom: -90px; // magic number proven experts banner
    left: 0;
    width: 100%;
    height: calc(100% + 180px);
    background: rgba(0,127,180,0.1);
    background: linear-gradient(127deg, rgba(0,127,180,0) 0%, rgba(0,127,180,1) 35%, rgba(59,150,148,1) 64%, rgba(59,150,148,0) 100%);
    opacity: 0.5;
    transition: opacity 0.3s ease;
  }
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  position: relative;
  z-index: 9999;
}

.modal-container {
  width: 75vw;
  height: calc(100vh - 180px);
  margin: 0px auto;
  background-color: transparent;
  transition: all 0.3s ease;

  &--scrollable {
    max-height: calc(100vh - 180px);
    overflow-y: scroll;
  }
}

.modal-enter-from {
  opacity: 0;
}

.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
